import SanityBlockContent from '@sanity/block-content-to-react';
import React from 'react';

export default function TextBlock({ pageData, place }) {
  return (
    <>
      <p>
        {pageData.date && `Date / ${pageData.date}`}{' '}
        {pageData.endDate && `- ${pageData.endDate}`}
        {pageData.enCours && `- en cours`}
      </p>
      <p>{place && `Lieux / ${place}`}</p>
      {pageData._rawDescription && (
        <SanityBlockContent
          blocks={pageData._rawDescription}
          projectId="53zz037m"
          dataset="production"
        />
      )}

      <p>{pageData.budget && `Budget / ${pageData.budget}`}</p>
      <p>{pageData.surface && `Surface / ${pageData.surface}`}</p>
      <p>
        {pageData.maitriseOeuvre &&
          `Maîtrise d'œuvre / ${pageData.maitriseOeuvre}`}
      </p>
      <p>
        {pageData.maitreOuvrage &&
          `Maître d'ouvrage / ${pageData.maitreOuvrage}`}
      </p>
    </>
  );
}
